import routes from './routes'
import { Fetch } from '../fetch'

class CarrierInformationService {
  get () {
    return Fetch('get', routes.carrierInformation, null)
  }

  update (payload) {
    return Fetch('put', routes.updateCarrierInformation, payload)
  }
}

export default new CarrierInformationService()
